// extracted by css-extract-rspack-plugin
export default {"cls1":"ContentFeedback-cls1_zfo","cls2":"ContentFeedback-cls2_g3I ContentFeedback-cls1_zfo"};